import { render, staticRenderFns } from "./Type2.vue?vue&type=template&id=fe36a940&scoped=true"
import script from "./Type2.vue?vue&type=script&lang=js"
export * from "./Type2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe36a940",
  null
  
)

export default component.exports